import { useContext, useEffect, useState } from "react";
import "./PanditBooking.css";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import DatePicker from "react-date-picker";
import Select from "react-select";
import { ERROR_MESSAGES } from "../../Components/GlobalErrorMessage";
import { customSelectStyles, SelectLanguageOptions } from "../../middlewares/Utils";
import { GetPanditListDataAPI } from "../../ApiServices/PanditList/PanditList";
import CODModal from "./CODModal";
import axios from "axios";
import {
  BaseUrl,
  GetPhonePayPaymentLink,
  RazorPayKey,
  RazorPayName,
  RazorPaySecretKey,
} from "../../BaseUrl/BaseUrl";
import Mylogo from "../../assets/images/new/newLogo.jpg";
import "../Stepper Form/stepper.css";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import { FaqModuleID, ServiceDiscounts } from "../../Components/enum";
import { LanguageList } from "../../ApiServices/DailyPanditAPI/DailyPanditApi";
import { LoaderContext } from "../../AuthContext/AuthContext";
import {
  CityLookupList,
  StateLookupList,
} from "../../ApiServices/Other/StateLookupListApi";
import PhonePayCODModal from "./PhonePayCODModal";
import { createDevOrder, verifyDevPayment } from "../../ApiServices/RazorPayConfirmationApi/RazorPayConfirmationApi";
import { handleProceedRemainingPayment } from "../../Components/RazorPay/RazorPayFunction";
import { Button } from "react-bootstrap";
import CouponModal from "../../Components/CouponModal";
import { GetUserWalletAmount } from "../../ApiServices/UserWallet/UserWalletApi";

const steps = [
  "Booking Details",
  // "Select Pandit",
  "Booking Preview",
  "Payment Status",
];

const PanditBooking = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [showCODModal, setShowCODModal] = useState(null);
  const [showPhonePayCODModal, setShowPhonePayCODModal] = useState(null);
  const [findPandit, setFindPandit] = useState(null);
  const [selectedPandit, setSelectedPandit] = useState(null);
  const [orderID, setOrderID] = useState();
  const [panditSelectionError, setPanditSelectionError] = useState(null);
  const [error, setError] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState(null);
  const [showBookingReviewModal, setShowBookingReviewModal] = useState(null);
  const [panditDataList, setPanditDataList] = useState([]);
  const navigate = useNavigate();
  const { setLoader, pujaStatus } = useContext(LoaderContext);
  const [languageOption, setLanguageOption] = useState([]);
  const [errorMessage, setErrorMessage] = useState();
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [appliedCoupon, setAppliedCoupon] = useState({
    CouponCode: null,
    isApplied: false,
    CoupenAmount: 0,
    walletAmount: 0,
    couponCodeID: null
  });
  const [isWalletApplied, setIsWalletApplied] = useState(false);

  const [productBookingData, setProductBookingData] = useState({
    date: null,
    time: null,
    time24: null,
    languageID: null,
    landmark: null,
    address: null,
    pincode: null,
    city: null,
    state: null,
    needSamagri: "yes",
    deepdanNote: null,
    needDrySamagri: 'yes',
    needWetSamagri: 'no',
    whatsAppNo: null, gotra: null, fullName: null
  });
  const [stateLookupList, setStateLookupList] = useState([]);
  const [cityLookupList, setCityLookupList] = useState([]);
  const userID = localStorage.getItem("userID");
  const [couponAmount, setCouponAmount] = useState(0)
  const [walletAmount, setWalletAmount] = useState(9000)
  const pujaDetails = location.state?.pujaDetailsData;
  const pujaPrice = location.state?.PujaPrice;
  const discountAmount = location.state?.discountAmount;
  const SGST = 9;
  const CGST = 9;

  const fromDate = dayjs();

  const product = location.state?.pujaDetailsData;


  // console.log("productBookingData", productBookingData);
  const [couponObj, setCouponObj] = useState({
    userID: userID,
    serviceID: FaqModuleID?.PujaBooking,
    subModuleID: [pujaDetails?.pujaId],
    orderAmount: Math.round(pujaPrice)

  })
  const [razorPayData, setRazorPayData] = useState({
    PB_DATE: null,
    PB_TIME: null,
    PB_LANGAUGE: null,
    PB_SAMAGRI: null,
    PB_PRICE: null,
    PB_SAMAGRIPRICE: null,
    PANDIT_ID: null,
    USER_ID: null,
    REFERENCES_NO: "",
    ADDRESS: null,
    PUJA_ID: null,
    PAYMENT_TYPE: null,
    CONVINIENCE_FEE: null,
    TAX: null,
    EXTRA: null,
    TRANSACTION_ID: "",
    TRANSACTION_AMT: "",
  });

  // console.log("razorPayData", location.state);
  let totalPrice = 0;

  totalPrice =
    Math.round(pujaPrice - discountAmount) +
    (pujaDetails?.CategoryType !== "Deepdaan" &&
      productBookingData?.needSamagri === "yes"
      ? parseFloat(pujaDetails?.pujaSamagriPrice)
      : 0) +
    parseFloat(pujaDetails?.SamagriPriceTaxAmount || 0) +
    parseFloat(pujaDetails?.convenienceFee || 0) +
    parseFloat(pujaDetails?.ConvinienceFeeTaxAmount || 0);

  let UpdatedTotal = Math.round(pujaPrice - discountAmount)
  if (pujaDetails?.CategoryType !== "Deepdaan") {
    if (productBookingData?.needWetSamagri === "yes" && productBookingData?.needDrySamagri === "yes") {
      UpdatedTotal = UpdatedTotal + ((Number(pujaDetails?.WetSamagriPrice) +
        Number(pujaDetails?.WetSamagriPriceTaxAmount)) + (Number(pujaDetails?.DrySamagriprice) +
          Number(pujaDetails?.DrySamagriPriceTaxAmount)))
    } else if (productBookingData?.needWetSamagri === "yes" && productBookingData?.needDrySamagri === "no") {
      UpdatedTotal = UpdatedTotal + (Number(pujaDetails?.WetSamagriPrice) +
        Number(pujaDetails?.WetSamagriPriceTaxAmount))
    } else if (productBookingData?.needWetSamagri === "no" && productBookingData?.needDrySamagri === "yes") {
      UpdatedTotal = UpdatedTotal + (Number(pujaDetails?.DrySamagriprice) +
        Number(pujaDetails?.DrySamagriPriceTaxAmount))
    }
  }
  UpdatedTotal = UpdatedTotal + parseFloat(pujaDetails?.convenienceFee || 0) +
    parseFloat(pujaDetails?.ConvinienceFeeTaxAmount || 0)

  const Tax = Math.round(
    (ServiceDiscounts.panditBookingDiscount / 100) * Number(UpdatedTotal)
  );

  const grandTotal = Math.round(UpdatedTotal - couponAmount);

  const [modelRequestData, setModelRequestData] = useState({
    totalPrice: null,
    amountEntered: null,
    moduleName: null,
    couponCode: null
  });

  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      if (currentStep === 0) {
        setCurrentStep(1); // Move to "Booking Preview"
      } else {
        setCurrentStep(currentStep + 1);
      }
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      if (currentStep === 2) {
        setAppliedCoupon((prev) => ({
          ...prev, CouponCode: null,
          isApplied: false,
          CoupenAmount: 0,
          walletAmount: 0
        }))
        setIsWalletApplied(false)
        setCurrentStep(1); // Move back to "Booking Preview"

      } else {
        setAppliedCoupon((prev) => ({
          ...prev, CouponCode: null,
          isApplied: false,
          CoupenAmount: 0,
          walletAmount: 0
        }))
        setIsWalletApplied(false)
        setCurrentStep(currentStep - 1);
      }
    }
  };
  useEffect(() => {
    GetPanditListData();
  }, [productBookingData?.languageID]);

  useEffect(() => {
    // debugger;
    setRazorPayData((prev) => ({
      ...prev,
      PB_DATE: productBookingData.date,
      PB_TIME: productBookingData.time,
      PB_LANGAUGE: SelectLanguageOptions.find(
        (item) => item.value === productBookingData.languageID
      )?.label,
      PB_SAMAGRI: productBookingData.needSamagri,
      PB_PRICE: pujaPrice,
      PB_SAMAGRIPRICE: pujaDetails?.pujaSamagriPrice,
      PANDIT_ID: selectedPandit,
      USER_ID: userID,
      REFERENCES_NO: "",
      ADDRESS: productBookingData?.address,
      PUJA_ID: pujaDetails?.pujaId,
      PAYMENT_TYPE: "ONLINE",
      CONVINIENCE_FEE: pujaDetails?.convenienceFee,
      TAX: null,
      EXTRA: null,
      TRANSACTION_ID: "",
      TRANSACTION_AMT: "",
    }));
  }, []);

  useEffect(() => {
    GetPanditListData();
  }, [currentStep]);

  useEffect(() => {
    GetLanguageListLookupListData();
    GetStateLookupListData();
    GetUserWalletAmountData()
  }, []);

  useEffect(() => {

    if (isWalletApplied && appliedCoupon?.isApplied === false) {

      const minAmount = Math.min(pujaPrice, walletAmount);
      const discountAmount = minAmount * 0.5;
      setAppliedCoupon((prev) => ({ ...prev, walletAmount: discountAmount }))
      setCouponAmount(discountAmount);
      // setCouponAmount(walletAmount)
    } else if (isWalletApplied === false && appliedCoupon?.isApplied === true) {
      setCouponAmount(appliedCoupon?.CoupenAmount)
    } else {
      setCouponAmount(0)
    }
  }, [isWalletApplied, appliedCoupon])
  useEffect(() => {
    if (
      productBookingData?.state !== null &&
      productBookingData?.state !== undefined &&
      productBookingData?.state !== ""
    ) {
      GetCityLookupListData(productBookingData?.state);
    }
  }, [productBookingData?.state]);

  useEffect(() => {
    if (((pujaStatus !== false && pujaStatus !== null) || pujaDetails?.PoojaTypeID === 1)) {

      setProductBookingData((prev) => ({ ...prev, needWetSamagri: 'yes' }))
    }
  }, [pujaDetails, pujaStatus])

  const GetStateLookupListData = async () => {
    try {
      const response = await StateLookupList(1); // Ensure it's correctly imported

      if (response?.ResponseCode === "0") {
        const languageLookupList = response?.DATA || [];

        const formattedLangList = languageLookupList.map((Lang) => ({
          value: Lang.StateID,
          label: Lang.StateName,
        }));

        setStateLookupList(formattedLangList);
      } else {
        console.error(
          "Failed to fetch sim Type lookup list:",
          response?.data?.statusMessage || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error fetching sim Type lookup list:", error);
    }
  };
  const GetCityLookupListData = async (ID) => {
    try {
      const response = await CityLookupList(ID); // Ensure it's correctly imported

      if (response?.ResponseCode === "0") {
        const languageLookupList = response?.DATA || [];

        const formattedLangList = languageLookupList.map((Lang) => ({
          value: Lang.DistrictID,
          label: Lang.DistrictName,
        }));

        setCityLookupList(formattedLangList);
      } else {
        console.error(
          "Failed to fetch sim Type lookup list:",
          response?.data?.statusMessage || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error fetching sim Type lookup list:", error);
    }
  };

  const GetLanguageListLookupListData = async () => {
    setLoader(true);
    try {
      const response = await LanguageList(); // Ensure it's correctly imported

      if (response?.ResponseCode === "0") {
        setLoader(false);

        const languageLookupList = response?.DATA || [];
        const formattedLangList = languageLookupList.map((Lang) => ({
          value: Lang.LANG_ID,
          label: Lang.LANG_NAME,
        }));

        setLanguageOption(formattedLangList);
      } else {
        setLoader(false);
        console.error(
          "Failed to fetch sim Type lookup list:",
          response?.data?.statusMessage || "Unknown error"
        );
      }
    } catch (error) {
      setLoader(false);
      console.error("Error fetching sim Type lookup list:", error);
    }
  };

  const GetUserWalletAmountData = async () => {

    setLoader(true);
    try {
      let response = await GetUserWalletAmount(userID); // Replace with actual import/function call
      if (response?.ResponseCode == "0") {
        setLoader(false);

        const list = response?.DATA || [];
        setWalletAmount(Number(list[0]?.WalletAmount) <= 0 ? 0 : list[0]?.WalletAmount)

      } else {
        console.error("Bad request");
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };


  //   const GetPanditListData = () => {};
  const GetPanditListData = async () => {

    const langID = productBookingData.languageID; // Adjust according to your data structure
    // setLoader(true);

    // debugger;
    try {
      const response = await GetPanditListDataAPI(
        userID,
        pujaDetails.PUJA_ID,
        langID,
        {
          START: 1,
          END: 10,
          WORD: "None",
          LATITUDE: "20.0086678",
          LONGITUDE: "73.7639264",
        }
      );

      if (response) {
        // setLoader(false);
        setPanditDataList(response.DATA);
      }
    } catch (error) {
      // setLoader(false);
      console.log(error);
    }
  };
  const HandleProductBookingBtnClicked = () => {

    let isValid = false;

    if (
      pujaDetails.CategoryType !== "Deepdaan" && pujaDetails?.PoojaTypeID !== 1 &&
      (productBookingData.date === null ||
        productBookingData.date === undefined ||
        productBookingData.date === "" ||
        productBookingData.time === null ||
        productBookingData.time === undefined ||
        productBookingData.time === "" ||
        productBookingData.landmark === null ||
        productBookingData.landmark === undefined ||
        productBookingData.landmark === "" ||
        productBookingData.languageID === null ||
        productBookingData.languageID === undefined ||
        productBookingData.languageID === "" ||
        productBookingData.address === null ||
        productBookingData.address === undefined ||
        productBookingData.address === "" ||
        productBookingData.state === null ||
        productBookingData.state === undefined ||
        productBookingData.state === "" ||
        productBookingData.city === null ||
        productBookingData.city === undefined ||
        productBookingData.city === "" ||
        productBookingData.pincode === null ||
        productBookingData.pincode === undefined ||
        productBookingData.pincode === "" ||
        productBookingData.needSamagri === null ||
        productBookingData.needSamagri === undefined ||
        productBookingData.needSamagri === "")
    ) {
      isValid = true;
      setError(true);
    } else if (
      pujaDetails.CategoryType === "Deepdaan" && pujaDetails?.PoojaTypeID !== 1 &&
      (productBookingData.date === null ||
        productBookingData.date === undefined ||
        productBookingData.date === "" ||
        productBookingData.deepdanNote === null ||
        productBookingData.deepdanNote === undefined ||
        productBookingData.deepdanNote === "" ||
        productBookingData.whatsAppNo === null ||
        productBookingData.whatsAppNo === undefined ||
        productBookingData.whatsAppNo?.length < 10 ||
        productBookingData.whatsAppNo === "")
    ) {
      isValid = true;
      setError(true);
    } else if (
      pujaDetails.CategoryType !== "Deepdaan" && pujaDetails?.PoojaTypeID === 1 &&
      (((productBookingData.date === null ||
        productBookingData.date === undefined ||
        productBookingData.date === "") && pujaDetails?.pujaId !== 10219) ||
        ((productBookingData.languageID === null ||
          productBookingData.languageID === undefined ||
          productBookingData.languageID === "") && pujaDetails?.pujaId !== 10219) ||
        productBookingData.address === null ||
        productBookingData.address === undefined ||
        productBookingData.address === "" ||
        productBookingData.needSamagri === null ||
        productBookingData.needSamagri === undefined ||
        productBookingData.needSamagri === "" ||
        productBookingData.fullName === null ||
        productBookingData.fullName === undefined ||
        productBookingData.fullName === "" ||
        productBookingData.gotra === null ||
        productBookingData.gotra === undefined ||
        productBookingData.gotra === ""
      )
    ) {
      isValid = true;
      setError(true);
    }

    // const api_Params = {
    //   date: productBookingData.date,
    //   time: productBookingData.time,
    //   languageID: productBookingData.languageID,
    //   landmark: productBookingData.landmark,
    //   address: productBookingData.address,
    //   pincode: productBookingData.pincode,
    //   city: productBookingData.city,
    //   state: productBookingData.state,
    //   needSamagri: productBookingData.needSamagri,
    // };

    if (!isValid) {
      //   navigate("/services/book-puja/puja-details/pandit-list", {
      //     state: { productBookingData: productBookingData, product: product },
      //   });
      // setCurrentStep(currentStep + 1)
      handleFindPandit();
      // nextStep();
    }
  };

  const handlePhonepayPayment = () => {
    let minPayableAmount = modelRequestData.amountEntered
      ? modelRequestData.amountEntered
      : Math.round(grandTotal);

    const PhonePayOption = {
      UserID: userID,
      MobileNumber: productBookingData.whatsAppNo,
      ModalName: "pujaBook",
      Amount: minPayableAmount,
    };

    const bookingData = {
      PB_DATE: productBookingData.date,
      PB_TIME: productBookingData.time,
      PB_LANGAUGE: languageOption.find(
        (item) => item.value === productBookingData.languageID
      )?.value,
      PB_SAMAGRI: productBookingData.needSamagri,
      PB_PRICE: pujaPrice,
      PB_SAMAGRIPRICE: pujaDetails?.pujaSamagriPrice,
      PANDIT_ID: findPandit === true ? null : selectedPandit,
      USER_ID: userID,
      REFERENCES_NO: "",
      ADDRESS: productBookingData?.address,
      PUJA_ID: pujaDetails?.pujaId,
      PAYMENT_TYPE: modelRequestData.amountEntered ? "COD" : "ONLINE",
      CONVINIENCE_FEE: pujaDetails?.convenienceFee,
      TAX: null,
      EXTRA: null,
      // TRANSACTION_ID: paymentId,
      TRANSACTION_AMT: minPayableAmount,
      PB_DiscountPercentage: pujaDetails?.pujaDiscount,
      PB_DiscountAmount: pujaDetails?.DiscountAmount,
      PB_Total: pujaDetails?.pujaPrice,
      PB_TaxPercentage: ServiceDiscounts.panditBookingDiscount,
      PB_TaxAmount: Tax,
      PB_GrandTotal: grandTotal,
      PAYMENT_STATUS: minPayableAmount === totalPrice ? "Completed" : "Pending",
      TRANSACTION_STATUS: "Success",
      SamagriPriceTaxAmount: pujaDetails?.SamagriPriceTaxAmount || 0,
      SamagriPriceTaxPercent: pujaDetails?.SamagriPriceTaxPercent || 0,
      ConvinienceFeeTaxPercent: pujaDetails?.ConvinienceFeeTaxPercent || 0,
      ConvinienceFeeTaxAmount: pujaDetails?.ConvinienceFeeTaxAmount || 0,
      WhatsappNumber: productBookingData.whatsAppNo,
      Remark: productBookingData.deepdanNote,
    };

    axios
      .post(`${BaseUrl}/${GetPhonePayPaymentLink}`, PhonePayOption)
      .then((res) => {
        if (res?.data?.success) {


          // Use navigate with state instead of window.location.href
          localStorage.setItem("PujaBookingData", JSON.stringify(bookingData));

          window.location.href = res.data.redirectUrl;
        } else {
          console.error("PhonePe Payment Failed:", res.data);
          alert("Something went wrong while creating the payment link.");
        }
      })
      .catch((error) => {
        console.error("PhonePe API Error:", error);
        alert("Failed to initiate PhonePe payment. Please try again.");
      });
  };

  // const BookPujaAPI = async () => {
  //   debugger;
  //   axios
  //     .post(`${BaseUrl}/BookPooja`, {
  //       PB_DATE: productBookingData.date,
  //       PB_TIME: productBookingData.time,
  //       PB_LANGAUGE: SelectLanguageOptions.find(
  //         (item) => item.value === productBookingData.languageID
  //       )?.label,
  //       PB_SAMAGRI: productBookingData.needSamagri,
  //       PB_PRICE: pujaDetails?.pujaPrice,
  //       PB_SAMAGRIPRICE: pujaDetails?.pujaSamagriPrice,
  //       PANDIT_ID: selectedPandit,
  //       USER_ID: userID,
  //       REFERENCES_NO: "",
  //       ADDRESS: productBookingData?.address,
  //       PUJA_ID: pujaDetails?.pujaId,
  //       PAYMENT_TYPE: "ONLINE",
  //       CONVINIENCE_FEE: pujaDetails?.convenienceFee,
  //       TAX: null,
  //       EXTRA: null,
  //       TRANSACTION_ID: "",
  //       TRANSACTION_AMT: "",
  //     })
  //     .then((res) => {
  //       if (res) {
  //         console.log(res);
  //         setOrderID(res.data.ID);
  //         localStorage.setItem("orderID", JSON.stringify(res.data.ID));
  //         orderIDReturned = res.data.ID;
  //       }
  //     });
  // };

  const handlePanditSelectionNext = () => {
    if (
      selectedPandit !== null &&
      selectedPandit !== undefined &&
      selectedPandit !== ""
    ) {
      // console.log("Panditselection");
      // nextStep();
    } else {
      setPanditSelectionError(true);
    }
  };

  const handleToDateChange = (newValue) => {
    if (dayjs(newValue).isValid()) {
      const newToDate = dayjs(newValue).format("YYYY-MM-DD");
      setProductBookingData((prev) => ({ ...prev, date: newToDate }));
    } else {
      setProductBookingData((prev) => ({ ...prev, date: null }));
    }
  };

  const handleLanguageChange = (selectedValue) => {
    setProductBookingData((prev) => ({
      ...prev,
      languageID: selectedValue.value,
    }));
  };

  const handlePanditCardClicked = (pandit) => {
    setSelectedPandit(pandit.PANDIT_ID);
    // console.log(pandit);
  };

  const handleCODClicked = () => {

    setModelRequestData((prev) => ({
      ...prev,
      totalPrice: grandTotal,
      tax: Tax,
      convenienceFee: product?.convenienceFee,
      convenienceFeeFax: product?.ConvinienceFeeTaxAmount,
      SamagriPriceTaxAmount:
        product?.ConvinienceFeeTaxPercent != 0
          ? product?.SamagriPriceTaxAmount
          : 0,
      amountEntered: Math.ceil(modelRequestData.totalPrice * 0.2)
    }));
    setShowCODModal(true);
  };
  const handlePhonePayCODClicked = () => {

    setModelRequestData((prev) => ({
      ...prev,
      totalPrice: grandTotal,
      tax: Tax,
      convenienceFee: product?.convenienceFee,
      convenienceFeeFax: product?.ConvinienceFeeTaxAmount,
      SamagriPriceTaxAmount:
        product?.ConvinienceFeeTaxPercent != 0
          ? product?.SamagriPriceTaxAmount
          : 0,
    }));
    setShowPhonePayCODModal(true);
  };

  function formatToIndianCurrency(amount) {
    if (!amount) return "";

    const [integerPart, decimalPart] = amount.toString().split(".");

    // Format the integer part using Indian numbering system
    const formattedIntegerPart = integerPart.replace(
      // Match groups of 3 digits initially, then groups of 2 digits
      /(\d)(?=(\d\d)+\d$)/g,
      "$1,"
    );

    // Return the formatted value with the decimal part (if present)
    return decimalPart !== undefined
      ? `${formattedIntegerPart}.${decimalPart}`
      : formattedIntegerPart;
  }

  const renderStarRating = (rating) => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      if (i < Math.floor(rating)) {
        stars.push(<i key={i} className="fa fa-star filled-star"></i>); // Full Star
      } else if (i < rating) {
        stars.push(<i key={i} className="fa fa-star-half-alt half-star"></i>); // Half Star
      } else {
        stars.push(<i key={i} className="fa fa-star empty-star"></i>); // Empty Star
      }
    }
    return stars;
  };


  const handleRazorpayPayment = async () => {

    let orderIDReturned = null
    let minPayableAmount = modelRequestData.amountEntered
      ? modelRequestData.amountEntered
      : Math.round(grandTotal);

    const PlaceOrderResponse = await handleProceedRemainingPayment(minPayableAmount)

    setLoader(true)
    if (PlaceOrderResponse?.status === 1) {

      axios
        .post(`${BaseUrl}/BookPooja`, {
          PB_DATE: productBookingData.date,
          PB_TIME: productBookingData.time,
          PB_LANGAUGE: languageOption.find(
            (item) => item.value === productBookingData.languageID
          )?.value,
          PB_SAMAGRI: productBookingData.needSamagri,
          PB_PRICE: pujaPrice,
          PB_SAMAGRIPRICE: pujaDetails?.pujaSamagriPrice,
          PANDIT_ID: findPandit === true ? null : selectedPandit,
          USER_ID: userID,
          REFERENCES_NO: "",
          ADDRESS: productBookingData?.address,
          PUJA_ID: pujaDetails?.pujaId,
          PAYMENT_TYPE: modelRequestData.amountEntered ? "COD" : "ONLINE",
          CONVINIENCE_FEE: pujaDetails?.convenienceFee,
          TAX: null,
          EXTRA: null,
          TRANSACTION_ID: PlaceOrderResponse?.razorpay_payment_id,
          TRANSACTION_AMT: minPayableAmount,
          // New params
          PB_DiscountPercentage: pujaDetails?.pujaDiscount,
          PB_DiscountAmount: discountAmount,
          PB_Total: pujaDetails?.pujaPrice,
          PB_TaxPercentage: ServiceDiscounts.panditBookingDiscount,
          PB_TaxAmount: Tax,
          PB_GrandTotal: grandTotal,
          PAYMENT_STATUS:
            minPayableAmount === totalPrice ? "Completed" : "Pending",
          TRANSACTION_STATUS: "Success",
          SamagriPriceTaxAmount: pujaDetails?.SamagriPriceTaxAmount || 0,
          SamagriPriceTaxPercent: pujaDetails?.SamagriPriceTaxPercent || 0,
          ConvinienceFeeTaxPercent:
            pujaDetails?.ConvinienceFeeTaxPercent || 0,
          ConvinienceFeeTaxAmount:
            pujaDetails?.ConvinienceFeeTaxAmount || 0,
          WhatsappNumber: productBookingData.whatsAppNo,
          Remark: productBookingData.deepdanNote,
          PoojaTypeID: (pujaStatus === false || pujaStatus === null && pujaDetails?.PoojaTypeID !== 1) ? 2 : 1,
          CouponCodeID: appliedCoupon?.couponCodeID,
          CouponCodeAmount: appliedCoupon?.CoupenAmount,
          WalletAmount: appliedCoupon?.walletAmount,
          DrySamagriprice: productBookingData?.needDrySamagri === 'yes' ? pujaDetails?.DrySamagriprice : 0,
          WetSamagriPrice: productBookingData?.needWetSamagri === 'yes' ? pujaDetails?.WetSamagriPrice : 0,
          WetSamagriPriceTaxPercent: pujaDetails?.WetSamagriPriceTaxPercent,
          DrySamagriPriceTaxPercent: pujaDetails?.DrySamagriPriceTaxPercent,
          NeedDrySamagri: productBookingData?.needDrySamagri,
          NeedWetSamagri: productBookingData?.needWetSamagri,
          DrySamagriPriceTaxAmount: pujaDetails?.DrySamagriPriceTaxAmount,
          WetSamagriPriceTaxAmount: pujaDetails?.WetSamagriPriceTaxAmount,
          CustomerName: pujaDetails?.fullName,
          Gotra: pujaDetails?.gotra,
        })
        .then((res) => {
          if (res) {
            console.log(res);
            setOrderID(res.data.ID);
            setShowCODModal(false);
            // nextStep();
            // localStorage.setItem("orderID", JSON.stringify(res.data.ID));
            orderIDReturned = res.data.ID;
            setLoader(false)
            navigate("/thank-you", {
              state: { moduleName: "PujaBooking", isHomamPuja: pujaDetails?.PUJACAT_ID === 39 },
            });
          }
        });
    } else if (PlaceOrderResponse?.status === 0) {
      setLoader(false)
      alert('Order Failed !')
    }
  };

  const VerifyOrder = async (apiParam) => {
    setLoader(true);
    try {
      let response = await verifyDevPayment(apiParam); // Replace with actual import/function call
      if (response?.ResponseCode == "0") {
        setLoader(false);
        navigate("/thank-you", {
          state: { moduleName: "PujaBooking" },
        });
        // orderId = response
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
    }
  }

  // const BookPujaAPI = async () => {
  //   debugger;
  //   axios
  //     .post(`${BaseUrl}/BookPooja`, {
  //       PB_DATE: productBookingData.date,
  //       PB_TIME: productBookingData.time,
  //       PB_LANGAUGE: SelectLanguageOptions.find(
  //         (item) => item.value === productBookingData.languageID
  //       )?.label,
  //       PB_SAMAGRI: productBookingData.needSamagri,
  //       PB_PRICE: pujaDetails?.pujaPrice,
  //       PB_SAMAGRIPRICE: pujaDetails?.pujaSamagriPrice,
  //       PANDIT_ID: selectedPandit,
  //       USER_ID: userID,
  //       REFERENCES_NO: "",
  //       ADDRESS: productBookingData?.address,
  //       PUJA_ID: pujaDetails?.pujaId,
  //       PAYMENT_TYPE: "ONLINE",
  //       CONVINIENCE_FEE: pujaDetails?.convenienceFee,
  //       TAX: null,
  //       EXTRA: null,
  //       TRANSACTION_ID: "",
  //       TRANSACTION_AMT: "",
  //     })
  //     .then((res) => {
  //       if (res) {
  //         console.log(res);
  //         setOrderID(res.data.ID);
  //         localStorage.setItem("orderID", JSON.stringify(res.data.ID));
  //         orderIDReturned = res.data.ID;
  //       }
  //     });
  // };

  const handleFindPandit = () => {
    setFindPandit(true);
    nextStep();
  };


  const handleOpenCoupenModal = () => {
    setCouponObj((prev) => ({
      ...prev,
      userID: userID,
      serviceID: 1,
      subModuleID: [
        1,
        2
      ],
      orderAmount: null
    }))
    setModelRequestData((prev) => ({ ...prev, moduleName: 'PujaBooking' }))
    setShowModal(true)
  }

  return (
    <div style={{ background: "#F1F6F7", paddingTop: "30px" }}>
      {/* Step Indicator */}
      <div className="stepper-wrapper">
        {steps.map((step, index) => (
          <div
            key={index}
            className={`stepper-item ${index < currentStep
              ? "completed"
              : index === currentStep
                ? "active"
                : ""
              }`}
          >
            <div className="step-counter">{index + 1}</div>
            <div className="step-name" style={{ fontSize: "small" }}>
              {step}
            </div>
          </div>
        ))}
      </div>

      {/* Step Content */}
      <div
        className="step-content"
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "10px 30px",
          background: "#F1F6F7",
        }}
      >
        {currentStep === 0 && (
          <>
            <div className="booking-details-container ">
              {pujaDetails?.CategoryType !== "Deepdaan" && (
                <div
                  className="booking-details-left"
                // style={{
                //   padding: "10px 20px",
                //   display: "flex",
                //   alignItems: "center",
                //   justifyContent: "center",
                // }}
                >
                  <h5>Booking Details</h5>
                  <hr />
                  <div className="row ">
                    {/* Date */}
                    {pujaDetails?.pujaId !== 10219 && <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                      <label
                        htmlFor="bookingDate"
                        style={{ textAlign: "left" }}
                      >
                        Date<span style={{ color: "red" }}>*</span>
                      </label>
                      <DatePicker
                        id="bookingDate"
                        value={productBookingData?.date || ""}
                        minDate={
                          (pujaStatus === false || pujaStatus === null && pujaDetails?.PoojaTypeID !== 1)
                            ? new Date(new Date().setDate(new Date().getDate() + 3))
                            : new Date(new Date().setDate(new Date().getDate() + 2))
                        }
                        clearIcon={null}
                        onChange={handleToDateChange}
                        format="dd/MM/yyyy"
                        className="custom-date-picker"
                      />

                      {error && !productBookingData.date && (
                        <span className="error-msg">{ERROR_MESSAGES}</span>
                      )}
                    </div>
                    }
                    {/* Time */}
                    {(pujaStatus === false || pujaStatus === null && pujaDetails?.PoojaTypeID !== 1) && (
                      <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                        <label

                          style={{ textAlign: "left" }}
                        >
                          Time<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          id="bookingTime"
                          type="time"
                          className="custom-form-control"
                          value={productBookingData.time24 || ""}
                          onClick={(e) =>
                            e.target.showPicker && e.target.showPicker()
                          }
                          onChange={(e) => {
                            const [hour, minute] = e.target.value.split(":");
                            let hr = parseInt(hour, 10);
                            const ampm = hr >= 12 ? "PM" : "AM";
                            hr = hr % 12 || 12; // convert hoga yaha pr -> 13 ka -> 1
                            const formattedTime = `${hr}:${minute} ${ampm}`;

                            setProductBookingData((prev) => ({
                              ...prev,
                              time: formattedTime,
                              time24: e.target.value,
                            }));
                          }}
                        />
                        {error && !productBookingData.time && (
                          <span className="error-msg">{ERROR_MESSAGES}</span>
                        )}
                      </div>
                    )}


                    {/* Select Language */}
                    {pujaDetails?.pujaId !== 10219 && <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                      <label htmlFor="language" style={{ textAlign: "left" }}>
                        Select Language<span style={{ color: "red" }}>*</span>
                      </label>
                      <Select

                        options={languageOption}
                        onChange={handleLanguageChange}
                        value={languageOption.find(
                          (item) => item.value === productBookingData.languageID
                        )}
                        styles={customSelectStyles}
                      />

                      {error && !productBookingData.languageID && (
                        <span className="error-msg">{ERROR_MESSAGES}</span>
                      )}
                    </div>}{" "}

                    {/* State */}
                    {(pujaStatus === false || pujaStatus === null && pujaDetails?.PoojaTypeID !== 1) && (
                      <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                        <label htmlFor="state" style={{ textAlign: "left" }}>
                          State<span style={{ color: "red" }}>*</span>
                        </label>
                        <Select

                          options={stateLookupList}
                          value={stateLookupList.find(
                            (item) => item.value === productBookingData.state
                          )}
                          onChange={(selectedOption) => {
                            setProductBookingData((prev) => ({
                              ...prev,
                              state: selectedOption?.value,
                            }));
                          }}
                          styles={customSelectStyles}
                        />
                        {error && !productBookingData.state && (
                          <span className="error-msg">{ERROR_MESSAGES}</span>
                        )}
                      </div>
                    )}


                    {/* Gotra and Name */}
                    {(pujaStatus === true || pujaDetails?.PoojaTypeID === 1) && (

                      <>
                        {/*  Full Name */}
                        <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                          <label htmlFor="fullName" style={{ textAlign: "left" }}>
                            Full Name<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            id="fullName"
                            type="text"
                            className="custom-form-control"
                            value={productBookingData.fullName || ""}
                            onChange={(e) => {
                              let inputVal = e.target.value.trimStart();
                              setProductBookingData((prev) => ({
                                ...prev,
                                fullName: inputVal,
                              }));
                            }}
                            placeholder="Enter Full Name"
                          />
                          {error && !productBookingData.fullName && (
                            <span className="error-msg">{ERROR_MESSAGES}</span>
                          )}
                        </div>
                        {/* Gotra */}
                        <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                          <label htmlFor="gotra" style={{ textAlign: "left" }}>
                            Gotra<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            id="gotra"
                            type="text"
                            className="custom-form-control"
                            value={productBookingData.gotra || ""}
                            onChange={(e) => {
                              let inputVal = e.target.value.trimStart();
                              setProductBookingData((prev) => ({
                                ...prev,
                                gotra: inputVal,
                              }));
                            }}
                            placeholder="Enter Gotra"
                          />
                          {error && !productBookingData.gotra && (
                            <span className="error-msg">{ERROR_MESSAGES}</span>
                          )}
                        </div>{" "}

                      </>


                    )}

                    {(pujaStatus === false || pujaStatus === null && pujaDetails?.PoojaTypeID !== 1) && (
                      <>
                        {/* City */}
                        <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                          <label htmlFor="City" style={{ textAlign: "left" }}>
                            City<span style={{ color: "red" }}>*</span>
                          </label>
                          <Select

                            options={cityLookupList}
                            value={cityLookupList.find(
                              (item) => item.value === productBookingData.city
                            )}
                            onChange={(selectedOption) => {
                              setProductBookingData((prev) => ({
                                ...prev,
                                city: selectedOption?.value,
                              }));
                            }}
                            styles={customSelectStyles}
                          />
                          {error && !productBookingData.city && (
                            <span className="error-msg">{ERROR_MESSAGES}</span>
                          )}
                        </div>{" "}

                        {/* Landmark */}
                        <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                          <label htmlFor="landmark" style={{ textAlign: "left" }}>
                            Landmark<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            id="landmark"
                            type="text"
                            className="custom-form-control"
                            value={productBookingData.landmark || ""}
                            onChange={(e) => {
                              let inputVal = e.target.value.trimStart();
                              setProductBookingData((prev) => ({
                                ...prev,
                                landmark: inputVal,
                              }));
                            }}
                            placeholder="Enter Landmark"
                          />
                          {error && !productBookingData.landmark && (
                            <span className="error-msg">{ERROR_MESSAGES}</span>
                          )}
                        </div>
                      </>
                    )}

                    {/* Address */}
                    <div className={`${(pujaStatus === true || pujaDetails?.PoojaTypeID === 1) ? 'col-md-12' : 'col-md-6'} col-sm-12 mb-2 d-flex flex-column`}>
                      <label htmlFor="address" style={{ textAlign: "left" }}>
                        Address<span style={{ color: "red" }}>*</span>
                      </label>
                      <textarea
                        id="address"
                        className="custom-form-control"
                        value={productBookingData.address || ""}
                        onChange={(e) => {
                          let inputVal = e.target.value.trimStart();
                          setProductBookingData((prev) => ({
                            ...prev,
                            address: inputVal,
                          }));
                        }}
                        placeholder="Enter Address"
                      />
                      {error && !productBookingData.address && (
                        <span className="error-msg">{ERROR_MESSAGES}</span>
                      )}
                    </div>
                    {/* Pincode */}
                    {(pujaStatus === false || pujaStatus === null && pujaDetails?.PoojaTypeID !== 1) && (
                      <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                        <label htmlFor="pincode" style={{ textAlign: "left" }}>
                          Pincode<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          id="pincode"
                          type="text"
                          maxLength={6}
                          className="custom-form-control"
                          value={productBookingData.pincode || ""}
                          onChange={(e) => {
                            let inputVal = e.target.value.replace(/\D/g, "");
                            setProductBookingData((prev) => ({
                              ...prev,
                              pincode: inputVal,
                            }));
                          }}
                          placeholder="Enter Pincode"
                        />
                        {error && !productBookingData.pincode && (
                          <span className="error-msg">{ERROR_MESSAGES}</span>
                        )}
                      </div>
                    )}


                  </div>

                  {(pujaStatus === false || pujaStatus === null && pujaDetails?.PoojaTypeID !== 1) && (
                    <>
                      <div>
                        Do you want Samagri for this Puja?
                      </div>
                      <div className="row mb-3">
                        {/* Wet Samagri */}
                        {Number(pujaDetails?.WetSamagriPrice) > 0 && (
                          <div className="col-md-6 col-sm-12 d-flex align-items-center">
                            <label className="fw-semibold me-2 mb-0">Wet Samagri:</label>
                            <div className="d-flex align-items-center">
                              <label className="me-3 mb-0">
                                <input
                                  type="radio"
                                  name="wetSamagri"
                                  value="yes"
                                  checked={productBookingData.needWetSamagri === "yes"}
                                  onChange={(e) =>
                                    setProductBookingData((prev) => ({
                                      ...prev,
                                      needWetSamagri: e.target.value,
                                    }))
                                  }
                                  className="me-1"
                                />
                                Yes
                              </label>
                              <label className="mb-0">
                                <input
                                  type="radio"
                                  name="wetSamagri"
                                  value="no"
                                  checked={productBookingData.needWetSamagri === "no"}
                                  onChange={(e) =>
                                    setProductBookingData((prev) => ({
                                      ...prev,
                                      needWetSamagri: e.target.value,
                                    }))
                                  }
                                  className="me-1"
                                />
                                No
                              </label>
                            </div>
                          </div>
                        )}
                        {/* Dry Samagri */}
                        {Number(pujaDetails?.DrySamagriprice) > 0 && (
                          <div className="col-md-6 col-sm-12 d-flex align-items-center">
                            <label className="fw-semibold me-2 mb-0">Dry Samagri:</label>
                            <div className="d-flex align-items-center">
                              <label className="me-3 mb-0">
                                <input
                                  type="radio"
                                  name="drySamagri"
                                  value="yes"
                                  checked={productBookingData?.needDrySamagri === "yes"}
                                  onChange={(e) =>
                                    setProductBookingData((prev) => ({
                                      ...prev,
                                      needDrySamagri: e.target.value,
                                    }))
                                  }
                                  className="me-1"
                                />
                                Yes
                              </label>
                              <label className="mb-0">
                                <input
                                  type="radio"
                                  name="drySamagri"
                                  value="no"
                                  checked={productBookingData.needDrySamagri === "no"}
                                  onChange={(e) =>
                                    setProductBookingData((prev) => ({
                                      ...prev,
                                      needDrySamagri: e.target.value,
                                    }))
                                  }
                                  className="me-1"
                                />
                                No
                              </label>
                            </div>
                          </div>
                        )}


                      </div>

                      {/* Price Message Centered */}

                      <div className="row">
                        <div className="col-12 d-flex justify-content-center">
                          <div
                            style={{
                              background: "linear-gradient(90deg, #eeb11a, #a52444)",
                              padding: "5px 15px",
                              borderRadius: "8px",
                              fontWeight: "bold",
                              textAlign: "center",
                              color: "white",
                              minWidth: "320px",
                              fontSize: '16px'
                            }}
                          >
                            {productBookingData?.needWetSamagri === "yes" &&
                              productBookingData?.needDrySamagri === "yes" ? (
                              <>
                                Samagri Amount: ₹{" "}
                                {formatToIndianCurrency(
                                  (Number(pujaDetails?.DrySamagriprice || 0) +
                                    Number(pujaDetails?.WetSamagriPrice || 0))
                                )}
                              </>
                            ) : productBookingData?.needWetSamagri === "yes" ? (
                              <>
                                Wet Samagri Amount: ₹{" "}
                                {formatToIndianCurrency(pujaDetails?.WetSamagriPrice || 0)}
                              </>
                            ) : productBookingData?.needDrySamagri === "yes" ? (
                              <>
                                Dry Samagri Amount: ₹{" "}
                                {formatToIndianCurrency(pujaDetails?.DrySamagriprice || 0)}
                              </>
                            ) : (
                              <>All puja samagri will arrange by you  </>
                            )}

                          </div>
                        </div>
                      </div>

                    </>
                  )}
                </div>
              )}

              {/* Deepadan inputs */}
              {pujaDetails?.CategoryType === "Deepdaan" && (
                <div
                  className="booking-details-left"
                >
                  <h5>Booking Details</h5>
                  <hr />
                  <div className="row">
                    {/* Data */}
                    <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                      <label
                        htmlFor="bookingDate"
                        style={{ textAlign: "left" }}
                      >
                        Date<span style={{ color: "red" }}>*</span>
                      </label>
                      <DatePicker
                        id="bookingDate"
                        value={productBookingData?.date || ""}
                        minDate={
                          (pujaStatus === false || pujaStatus === null && pujaDetails?.PoojaTypeID !== 1)
                            ? new Date(new Date().setDate(new Date().getDate() + 3))
                            : new Date(new Date().setDate(new Date().getDate() + 2))
                        }
                        clearIcon={null}
                        onChange={handleToDateChange}
                        format="dd/MM/yyyy"
                        className="custom-date-picker"
                      />

                      {error && !productBookingData.date && (
                        <span className="error-msg">{ERROR_MESSAGES}</span>
                      )}
                    </div>


                    {/* Whatsapp Number */}
                    <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                      <label htmlFor="pincode" style={{ textAlign: "left" }}>
                        Whatsapp Number<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control rounded-3"
                        maxLength={10}
                        placeholder="Enter whatsapp number"
                        value={productBookingData.whatsAppNo}
                        onChange={(e) => {
                          setErrorMessage("");
                          let formattedNumber = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                          formattedNumber = formattedNumber.replace(
                            /^[0-5]/,
                            ""
                          );
                          setProductBookingData((prev) => ({
                            ...prev,
                            whatsAppNo: formattedNumber,
                          }));
                        }}
                      />
                      {error &&
                        (productBookingData.whatsAppNo === null ||
                          productBookingData.whatsAppNo === undefined ||
                          productBookingData.whatsAppNo === "" ? (
                          <span className="text-danger">
                            This field is required
                          </span>
                        ) : productBookingData.whatsAppNo?.length < 10 ? (
                          <span className="text-danger">Invalid number</span>
                        ) : (
                          ""
                        ))}
                    </div>
                  </div>

                  {/* {Deepdaan Note} */}
                  <div className="row">
                    <div className="col-md-12 col-sm-12 mb-2 d-flex flex-column">
                      <label htmlFor="address" style={{ textAlign: "left" }}>
                        Deepdaan Note<span style={{ color: "red" }}>*</span>
                      </label>
                      <textarea
                        id="address"
                        maxLength={100}
                        className="custom-form-control"
                        value={productBookingData.deepdanNote || ""}
                        onChange={(e) => {
                          let inputVal = e.target.value.trimStart();
                          setProductBookingData((prev) => ({
                            ...prev,
                            deepdanNote: inputVal,
                          }));
                        }}
                        placeholder="Enter Deepdaan Note"
                      />
                      {error && !productBookingData.deepdanNote && (
                        <span className="error-msg">{ERROR_MESSAGES}</span>
                      )}
                    </div>


                  </div>


                </div>
              )}

              <div className=" booking-details-right">
                <div className="price-summary" style={{ display: "relative" }}>
                  <h5>{pujaDetails?.pujaName}</h5>
                  <hr />
                  <ul>
                    <li>
                      <span>
                        {(pujaStatus === false || pujaStatus === null && pujaDetails?.PoojaTypeID !== 1) ? ' Puja Price (₹):' : ' Online Puja Price (₹):'}

                      </span>
                      {
                        <span>
                          {formatToIndianCurrency(
                            Math.round(pujaPrice - discountAmount)
                          )}
                        </span>
                      }
                    </li>
                    <hr></hr>


                    {/* productBookingData.needSamagri === "yes" */}
                    {pujaDetails?.CategoryType !== "Deepdaan" && (
                      <>
                        {(productBookingData?.needWetSamagri === "yes" && productBookingData?.needDrySamagri === "yes" && (((Number(pujaDetails?.WetSamagriPrice) +
                          Number(pujaDetails?.WetSamagriPriceTaxAmount)) + (Number(pujaDetails?.DrySamagriprice) +
                            Number(pujaDetails?.DrySamagriPriceTaxAmount))) !== 0))
                          ?
                          (
                            <>
                              <li>
                                <span>Samagri Price (₹):</span>
                                <span>
                                  {formatToIndianCurrency((Number(pujaDetails?.WetSamagriPrice) +
                                    Number(pujaDetails?.WetSamagriPriceTaxAmount)) + (Number(pujaDetails?.DrySamagriprice) +
                                      Number(pujaDetails?.DrySamagriPriceTaxAmount)))}

                                </span>
                              </li>
                              <hr></hr>
                            </>
                          )
                          : (productBookingData?.needWetSamagri === "yes" && productBookingData?.needDrySamagri === "no" && (Number(pujaDetails?.WetSamagriPrice) +
                            Number(pujaDetails?.WetSamagriPriceTaxAmount)) !== 0)
                            ?
                            (
                              <>
                                <li>
                                  <span> Wet Samagri Price (₹):</span>
                                  <span>
                                    {formatToIndianCurrency(
                                      (Number(pujaDetails?.WetSamagriPrice) +
                                        Number(pujaDetails?.WetSamagriPriceTaxAmount))
                                    )}

                                  </span>
                                </li>
                                <hr></hr>
                              </>
                            ) : (productBookingData?.needWetSamagri === "no" && productBookingData?.needDrySamagri === "yes")
                              ?
                              (
                                <>
                                  <li>
                                    <span> Dry Samagri Price (₹):</span>
                                    <span>
                                      {formatToIndianCurrency(
                                        Number(pujaDetails?.DrySamagriprice) +
                                        Number(pujaDetails?.DrySamagriPriceTaxAmount)
                                      )}

                                    </span>
                                  </li>
                                  <hr></hr>
                                </>
                              ) : ''
                        }


                      </>
                    )}
                    {Number(pujaDetails?.convenienceFee) !== 0 && (
                      <>
                        <li>
                          <span>Convenience Fee (₹):</span>
                          <span>
                            {Math.round(pujaDetails?.convenienceFee) +
                              Math.round(pujaDetails?.ConvinienceFeeTaxAmount) || 0}
                          </span>
                        </li>
                        <hr />
                      </>
                    )}


                    <li>
                      <span>Grand Total (₹):</span>
                      <span>
                        {" "}
                        {formatToIndianCurrency(Math.round(grandTotal))}
                      </span>
                    </li>
                  </ul>
                  {/* <p>Payment Type: COD</p>
                  <button className="place-order-btn">Place Order</button> */}
                  <div style={{ display: 'flex', justifyContent: 'end' }}>
                    <button
                      onClick={
                        currentStep === 0
                          ? HandleProductBookingBtnClicked
                          : currentStep === 1
                            ? handlePanditSelectionNext
                            : ""
                      }
                      disabled={currentStep === steps.length - 1}
                      className="Normal-app-btn"
                      style={{ padding: "5px 16px", fontSize: "14px" }}
                    >
                      Next
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </>
        )}

        {/* {currentStep === 1 && (
          <div className="panditList" style={{ width: "100%" }}>
            <div className="container">
              <div className="row mb-4">
                <div className="col-md-12 px-lg-5">
                  <div className="searching" style={{ marginTop: "50px" }}>
                    <div className="search-name">
                      <div className="input-group mb-3">
                        <input
                          type="text"
                         className="custom-form-control"
                          placeholder="Search Pandit"
                          onChange={(e) => setSearchKeyword(e.target.value)}
                          aria-label="Search Pandit"
                          aria-describedby="basic-addon1"
                          style={{
                            border: "1px solid #ced4da",
                            padding: "10px",
                            fontSize: "16px",
                          }}
                        />
                        <span
                          className="input-group-text"
                          id="basic-addon1"
                          style={{
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #ced4da",
                            cursor: "pointer",
                          }}
                        >
                          <a href="/pandit-list">
                            <i
                              className="fa fa-search search-btn"
                              style={{
                                fontSize: "18px",
                                color: "#6c757d",
                              }}
                            ></i>
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="padit-list-products mt-3">
                    <div className="row">
                      {panditDataList?.map((pandit) => (
                        <div
                          className="col-lg-3 col-md-4 col-sm-6 col-12 mb-4"
                          key={pandit.PANDIT_ID}
                        >
                          <div
                            className={`card pandit-card ${selectedPandit === pandit.PANDIT_ID
                              ? "selected"
                              : ""
                              }`}
                            onClick={() => handlePanditCardClicked(pandit)}
                          >

                            <div
                              className="card-img-container"
                              style={{ padding: "10px", objectFit: "cover" }}
                            >
                              <img
                                src={pandit.PHOTO}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = placeholderImg;
                                }}
                                alt={pandit.PANDIT_NAME}
                                className="card-img-top"
                              />
                            </div>


                            <div className="card-body text-center">
                              <h5 className="card-title">
                                {pandit.PANDIT_NAME}
                              </h5>
                              <p className="card-text">
                                <strong>Mobile:</strong> {pandit.MOBILE_NO}
                              </p>
                              <p className="card-text">
                                <strong>Experience:</strong> {pandit.EXPERIENCE}{" "}
                                years
                              </p>
                              <p className="card-text">
                                <strong>DOB:</strong>{" "}
                                {new Date(pandit.DOB).toLocaleDateString()}
                              </p>


                              <div className="rating">
                                {renderStarRating(
                                  parseFloat(pandit.PANDIT_RATING)
                                )}
                                <span className="rating-text">
                                  ({pandit.PANDIT_RATING})
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {" "}
                    {panditSelectionError &&
                      (selectedPandit === null ||
                        selectedPandit === undefined ||
                        selectedPandit === "") ? (
                      <span style={{ color: "red" }}>Please Select Pandit</span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <span className="text-center">

                  Didn't find a pandit you like?
                  <span
                    onClick={handleFindPandit}
                    style={{ color: "#a42642", cursor: "pointer" }}
                  >

                    Click here, and we will find one for you.
                  </span>
                </span>
              </div>
            </div>
          </div>
        )} */}

        {currentStep === 1 && (
          <div style={{ width: "100%" }}>
            <div className="p-3">
              <div className="row g-4 d-flex">
                <div
                  className="booking-preview col-md-5 text-center"
                  style={{
                    flex: "2",
                  }}
                >
                  <div className="booking-preview-details-puja">
                    <div className="booking-preview-details-puja-top">
                      <div className="booking-preview-details-puja-top-left">
                        <img
                          src={product?.pujaImage || placeholderImg}
                          onError={(e) => {
                            e.target.onerror = null; // Prevent infinite loop
                            e.target.src = placeholderImg; // Set fallback image
                          }}
                          alt=""
                        />
                      </div>
                      <div
                        className="booking-preview-details-puja-top-right"
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        <span className="puja-name">{product?.PUJA_NAME}</span>
                        {pujaDetails?.pujaId !== 10219 ? <span>Puja Date:  {dayjs(productBookingData.date).format('DD/MM/YYYY')}</span> :
                          <span>Puja Date:  27 September 2025</span>}
                        {pujaDetails?.CategoryType !== "Deepdaan" && (
                          pujaDetails?.pujaId !== 10219 ? <span>
                            Puja Language:{" "}
                            {
                              languageOption.filter(
                                (item) =>
                                  item.value === productBookingData.languageID
                              )[0]?.label
                            }
                          </span> :
                            <span>
                              Time: 4:00 pm – 6:00 pm

                            </span>
                        )}
                        {pujaDetails?.CategoryType !== "Deepdaan" && pujaDetails?.PoojaTypeID !== 1 && (
                          <span>
                            Puja Time:
                            <span className="mx-2">
                              {productBookingData.time}
                            </span>
                          </span>
                        )}
                        {pujaDetails?.CategoryType === "Deepdaan" && (
                          <span>
                            WhatsApp Number: {productBookingData.whatsAppNo}
                          </span>
                        )}
                        {(pujaStatus === false || pujaStatus === null && pujaDetails?.PoojaTypeID !== 1) ? (
                          <span>Puja Type : Offline</span>
                        ) : <span>Puja Type : Online</span>}
                        {pujaDetails?.CategoryType === "Deepdaan" && (
                          <span>
                            Deepdaan Note: {productBookingData.deepdanNote}
                          </span>
                        )}


                        {pujaDetails?.CategoryType === "Deepdaan" ? (
                          <p

                            style={{ textAlign: "justify" }}
                          >
                            <span className="fw-bold">Note </span> : You will receive deepdaan videos on your
                            whatsapp number
                          </p>
                        ) : pujaDetails?.PoojaTypeID === 1 ? (
                          pujaDetails?.pujaId !== 10219 ? <p>
                            <span className="fw-bold">Note </span> : video recording shall be sent to the family.
                          </p> : <p>
                            <span className="fw-bold">Note </span> : You will receive a separate email/WhatsApp message closer to the event date with the live streaming link to watch the Homam.
                          </p>
                        ) : <p>
                          <span className="fw-bold">Note </span> : You will receive pandit details within 24
                          hours
                        </p>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className=" booking-details-right">
                  <div className="price-summary">
                    <h5>{pujaDetails?.pujaName}</h5>
                    <hr />
                    <ul>
                      <li>
                        {appliedCoupon?.isApplied ? (
                          <div

                            style={{
                              backgroundColor: 'rgb(239 178 29)',
                              borderRadius: '10px',
                              padding: '10px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              cursor: 'pointer',
                              // fontWeight: 'bold',
                              color: '#000',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                              width: '100%'
                            }}
                          >
                            <div onClick={() => handleOpenCoupenModal()} style={{ display: 'flex', alignItems: 'center' }}>

                              <span>Applied Coupon</span>
                              {appliedCoupon && (
                                <>
                                  <span
                                    style={{
                                      border: '1px dotted #333',
                                      padding: '2px 6px',
                                      borderRadius: '4px',
                                      fontSize: '12px',
                                      backgroundColor: '#fff',
                                      color: '#333',
                                      marginLeft: '6px',
                                    }}
                                  >
                                    {appliedCoupon?.CouponCode}
                                  </span>

                                </>


                              )}
                            </div>
                            <span
                              onClick={() => {
                                setAppliedCoupon((prev) => ({
                                  ...prev, CouponCode: null,
                                  isApplied: false,
                                  CoupenAmount: 0,
                                  walletAmount: 0
                                }))
                              }}
                              style={{
                                // border: '1px dotted #333',
                                padding: '2px 6px',
                                borderRadius: '4px',
                                fontSize: '12px',
                                backgroundColor: '#fff',
                                color: '#a52444',
                                marginLeft: '6px',
                              }} >



                              Remove

                            </span>
                            <span style={{ fontSize: '20px', fontWeight: 'lighter' }}>›</span>
                          </div>
                        ) : (
                          <div
                            onClick={() => setShowModal(true)}
                            style={{
                              backgroundColor: 'rgb(239 178 29)',
                              borderRadius: '10px',
                              padding: '10px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              cursor: 'pointer',
                              // fontWeight: 'bold',
                              color: '#000',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                              width: '100%'
                            }}
                          >
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <div style={{
                                backgroundColor: '#a52444',
                                color: 'white',
                                borderRadius: '50%',
                                width: '24px',
                                height: '24px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14px',
                                marginRight: '10px',

                              }}>
                                %
                              </div>
                              <span style={{ fontWeight: '400' }}>View Coupons & Offers</span>

                            </div>
                            <span style={{ fontSize: '20px', fontWeight: 'bolder' }}>›</span>
                          </div>
                        )}

                      </li>
                      {walletAmount !== 0 && (
                        <li style={{ fontSize: 'smaller', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div

                            style={{
                              backgroundColor: 'rgb(239 178 29)',
                              borderRadius: '10px',
                              padding: '10px',
                              // display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              // cursor: 'pointer',
                              // fontWeight: 'bold',
                              color: '#000',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                              width: '100%'
                            }}
                          >
                            <div style={{ display: 'flex', alignItems: 'center' }}>

                              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', width: '100%' }}>
                                <input
                                  type="checkbox"
                                  checked={isWalletApplied}
                                  onChange={(e) => {
                                    setAppliedCoupon((PREV) => ({
                                      ...PREV, CouponCode: null,
                                      isApplied: false
                                    }))
                                    setIsWalletApplied(e.target.checked)
                                  }
                                  }

                                  style={{ cursor: 'pointer' }}
                                />
                                Available wallet amount (₹) {walletAmount}
                              </label>
                            </div>
                            {/* <div className="d-flex justify-content-center">

                              <small>(Upto 50% can be applied)</small>
                            </div> */}
                            {/* <span style={{ fontSize: '20px', fontWeight: 'lighter' }}>›</span> */}
                          </div>

                        </li>
                      )}


                      <hr></hr>
                      <li>
                        <span>
                          {(pujaStatus === false || pujaStatus === null && pujaDetails?.PoojaTypeID !== 1) ? ' Puja Price (₹):' : ' Online Puja Price (₹):'}

                        </span>
                        <span>
                          {formatToIndianCurrency(
                            Math.round(pujaPrice - discountAmount)
                          )}
                        </span>
                      </li>
                      {isWalletApplied && appliedCoupon?.isApplied === false ? (
                        <li style={{ fontSize: 'smaller' }}>
                          <span>
                            Applied Wallet Amount (₹)

                          </span>
                          <span>
                            {appliedCoupon?.walletAmount}
                          </span>
                        </li>
                      ) : isWalletApplied === false && appliedCoupon?.isApplied ? (
                        <li style={{ fontSize: 'smaller' }}>
                          <span>
                            Applied Coupon  Amount (₹)

                          </span>

                          <span>
                            (-) {couponAmount}
                          </span>
                        </li>
                      ) : ''}

                      <hr></hr>
                      {/* productBookingData.needSamagri === "yes" */}
                      {pujaDetails?.CategoryType !== "Deepdaan" && (
                        <>
                          {(productBookingData?.needWetSamagri === "yes" && productBookingData?.needDrySamagri === "yes" && ((Number(pujaDetails?.WetSamagriPrice) +
                            Number(pujaDetails?.WetSamagriPriceTaxAmount)) + (Number(pujaDetails?.DrySamagriprice) +
                              Number(pujaDetails?.DrySamagriPriceTaxAmount))) !== 0)
                            ?
                            (
                              <>
                                <li>
                                  <span>Samagri Price (₹):</span>
                                  <span>
                                    {formatToIndianCurrency((Number(pujaDetails?.WetSamagriPrice) +
                                      Number(pujaDetails?.WetSamagriPriceTaxAmount)) + (Number(pujaDetails?.DrySamagriprice) +
                                        Number(pujaDetails?.DrySamagriPriceTaxAmount)))}

                                  </span>
                                </li>
                                <hr></hr>
                              </>
                            )
                            : (productBookingData?.needWetSamagri === "yes" && productBookingData?.needDrySamagri === "no")
                              ?
                              (
                                <>
                                  <li>
                                    <span> Wet Samagri Price (₹):</span>
                                    <span>
                                      {formatToIndianCurrency(
                                        (Number(pujaDetails?.WetSamagriPrice) +
                                          Number(pujaDetails?.WetSamagriPriceTaxAmount))
                                      )}

                                    </span>
                                  </li>
                                  <hr></hr>
                                </>
                              ) : (productBookingData?.needWetSamagri === "no" && productBookingData?.needDrySamagri === "yes")
                                ?
                                (
                                  <>
                                    <li>
                                      <span> Dry Samagri Price (₹):</span>
                                      <span>
                                        {formatToIndianCurrency(
                                          Number(pujaDetails?.DrySamagriprice) +
                                          Number(pujaDetails?.DrySamagriPriceTaxAmount)
                                        )}

                                      </span>
                                    </li>
                                    <hr></hr>
                                  </>
                                ) : ''
                          }

                        </>
                      )}

                      {Number(pujaDetails?.convenienceFee) !== 0 && (
                        <>
                          <li>
                            <span>Convenience Fee (₹):</span>
                            <span>
                              {Math.round(pujaDetails?.convenienceFee) +
                                Math.round(pujaDetails?.ConvinienceFeeTaxAmount) || 0}
                            </span>
                          </li>
                          <hr />
                        </>
                      )}

                      <li>
                        <span>Grand Total (₹):</span>
                        <span>
                          {" "}
                          {formatToIndianCurrency(Math.round(grandTotal))}
                        </span>
                      </li>
                    </ul>
                    <div className="mt-3 d-flex justify-content-end gap-2">
                      {pujaDetails?.CategoryType !== "Deepdaan" && (
                        <>
                          {pujaDetails?.PoojaTypeID !== 1 && (
                            <button
                              style={{ padding: "5px 5px", fontSize: "14px" }}
                              className="Normal-app-btn"
                              onClick={handleCODClicked}
                            >
                              Cash On Delivery
                            </button>
                          )}

                          {/* <button
                            style={{ padding: "5px 5px", fontSize: "14px" }}
                            className="Normal-app-btn"
                            onClick={handlePhonePayCODClicked}
                          >
                            Phone Cod Delivery
                          </button> */}
                        </>
                      )}
                      <button
                        style={{ padding: "5px 16px", fontSize: "14px" }}
                        className="Normal-app-btn"
                        onClick={handleRazorpayPayment}
                      >
                        Pay Now
                      </button>
                      {/* <button
                        style={{ padding: "5px 16px", fontSize: "14px" }}
                        className="Normal-app-btn"
                        onClick={handlePhonepayPayment}
                      >
                        Phone Pay
                      </button> */}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        )}

        {currentStep === 2 && (
          <div>
            <div className="carousel-inner" role="listbox">
              <div className="item carousel-item-four active">
                <div className="">
                  <div className="row">
                    <div className="carousel slide carousel-slider">
                      <div className="carousel-position-four">
                        <div className="carousel-inner">
                          <div
                            className="banner-breadcrumb"
                            style={{
                              // backgroundImage: `url(${StupaImg})`,
                              width: "100%",
                              height: "100px",
                            }}

                          // style={{ backgroundImage: `url(${AboutImg})` }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row margin-bottom-40">
              <div className="col-md-12 col-sm-12">
                <div className="thankyou-box text-center bg-white p-5">
                  <h2
                    style={{
                      fontFamily: "Ubuntu",
                      textTransform: "capitalize",
                      color: "#504e4e",
                      fontSize: "32px",
                      marginBottom: "20px",
                    }}
                  >
                    Thank You for Ordering !
                  </h2>
                  <h4
                    className="text-success"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "18px",
                      fontWeight: "450",
                    }}
                  >
                    Your Order Is Successful
                  </h4>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Navigation Buttons */}
      {currentStep === 0 ? (
        <div
          className="navigation-buttons"
          style={{ marginRight: "50px", paddingBottom: "30px" }}
        >
          {/* <button
            onClick={prevStep}
            disabled={currentStep === 0}
            className="btn btn-secondary"
            style={{ backgroundColor: "#d7d7d7", color: "black" }}
          >
            Previous
          </button> */}
          {currentStep === 1 && (
            <button
              onClick={
                currentStep === 0
                  ? HandleProductBookingBtnClicked
                  : currentStep === 1
                    ? handlePanditSelectionNext
                    : ""
              }
              disabled={currentStep === steps.length - 1}
              className="Normal-app-btn"
              style={{ padding: "5px 16px", fontSize: "14px" }}
            >
              Next
            </button>
          )}

        </div>
      ) : currentStep === 1 ? (
        <div
          className="navigation-buttons"
          style={{ marginRight: "50px", paddingBottom: "30px" }}
        >
          <button
            className="Normal-app-btn"
            style={{ padding: "5px 16px", fontSize: "14px" }}
            // style={{ backgroundColor: "#d7d7d7", color: "black" }}
            onClick={prevStep}
          >
            Previous
          </button>
        </div>
      ) : currentStep === 2 ? (
        <div
          className="navigation-buttons"
          style={{ marginRight: "50px", paddingBottom: "30px" }}
        >
          <button className=" prev-btn" onClick={() => navigate("/")}>
            Home
          </button>
          <button
            className=" prev-btn"
            onClick={() => navigate("/my-order-puja-booking")}
          >
            My Orders
          </button>
        </div>
      ) : (
        <div
          className="navigation-buttons"
          style={{ marginRight: "50px", paddingBottom: "30px" }}
        >
          <button
            onClick={prevStep}
            disabled={currentStep === 0}
            className="Normal-app-btn"
            style={{ backgroundColor: "grey", color: "white" }}
          >
            Previous
          </button>
          <button
            onClick={
              currentStep === 0
                ? HandleProductBookingBtnClicked
                : currentStep === 1
                  ? handlePanditSelectionNext
                  : ""
            }
            disabled={currentStep === steps.length - 1}
            className="Normal-app-btn"
          >
            Next
          </button>
        </div>
      )}
      <CODModal
        show={showCODModal}
        onHide={() => setShowCODModal(false)}
        onConfirm={handleRazorpayPayment}
        modelRequestData={modelRequestData}
        setModelRequestData={setModelRequestData}
      />
      <PhonePayCODModal
        show={showPhonePayCODModal}
        onHide={() => setShowPhonePayCODModal(false)}
        onConfirm={handlePhonepayPayment}
        modelRequestData={modelRequestData}
        setModelRequestData={setModelRequestData}
      />
      <CouponModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        modelRequestData={modelRequestData}
        setAppliedCoupon={setAppliedCoupon}
        setIsWalletApplied={setIsWalletApplied}
        apiParam={couponObj} />
    </div>
  );
};

export default PanditBooking;
